export default "__VITE_ASSET__BcyKZCkI__"